import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import atoms from '@Components/Utilities/SandhillsAtoms';
import translator from '@Components/Utilities/Translator';
import { useRecoilValue } from 'recoil';

const AccountMenu = (props) => {
    const [showMobileMenuOptions, setShowMobileMenuOptions] = useState(false);
    const handleClick = () => setShowMobileMenuOptions(showMobileMenuOptions => !showMobileMenuOptions);
    const windowSize = useWindowSize();

    const listItems = (options) => {
        return (
            options.map(item => (
                <>
                    {item.UseAccordion ?
                        <div key={item.DisplayText}>
                            <Accordion className='side-menu__accordion' defaultExpanded={props.DefaultExpanded} disableGutters={true}>
                                <AccordionSummary key={item.DisplayText} expandIcon={<ExpandMoreIcon />} className='side-menu__accordion_summary'>
                                    <span className='side-menu__accordion_summary-text'>{item.DisplayText}</span>
                                </AccordionSummary>
                                <AccordionDetails className='side-menu__accordion_details'>
                                    {item.ChildTabs.map(childTab => (
                                        <li key={childTab.TabKey}>
                                            <a className={'side-menu__accordion_submenu ' + (props.activeTab == childTab.TabKey ? 'active' : '')} href={childTab.Url} target={childTab.OpensInNewTab ? '_blank' : '_self'}>
                                                {childTab.DisplayText}
                                                {childTab.OpensInNewTab && <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>}
                                            </a>
                                        </li>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        :
                        <div key={item.DisplayText}>
                            <li>
                                <a className={'menu-item ' + item.Class} href={item.Url} rel={item.Relation}>{item.DisplayText}</a>
                            </li>
                        </div>}
                </>
            ))
        );
    };

    return (
        <ul className='side-menu'>
            {windowSize.isMobile ?
                <Accordion className='side-menu__accordion'>
                    <AccordionSummary className='side-menu__accordion_summary' expandIcon={<ExpandMoreIcon />}>
                        <button className='menu-item side-menu__accordion_summary-text' onClick={handleClick}><strong>{props.activeTab == 'Messages' ? translator.translate("sandhills.messages") : props.MobileAccordionText} {props.activeTab == 'AuctionTime' ? '- AuctionTime' : props.activeTab == 'EquipmentFacts' ? '- EquipmentFacts' : props.activeTab == 'MyConsignmentRequestsView' ? translator.translate("sandhills.myquoterequests") : props.activeTab == 'MyQuoteRequests' ? translator.translate("sandhills.myquoterequests") : props.activeTab == 'MyAcceptedQuoteRequests' ? translator.translate("sandhills.myacceptedquoterequests") : ""}</strong></button>
                    </AccordionSummary>
                    <AccordionDetails className='side-menu__accordion_details'>
                        {listItems(props.MenuOptions)}
                        {props.IsEmployee && listItems(props.EmployeeMenuOptions)}
                    </AccordionDetails>
                </Accordion>
                :
                <div>
                    {listItems(props.MenuOptions)}
                    {props.IsEmployee && (
                        <>
                            <h2 className='employee-only-header'>Employee Only</h2>
                            {listItems(props.EmployeeMenuOptions)}
                        </>
                    )}
                </div>
            }
        </ul>
    );
};

export default AccountMenu;